<template>
  <Item
    tag="router-link"
    :to="{ name: 'contract', params: { id: value.id } }"
    :type="value.typename.toLowerCase()"
    :title="title"
  >
    <template #datetime>
      <div v-if="value.expiresAt" class="row middle">
        <FontAwesomeIcon :icon="['fal', 'calendar-exclamation']" style="margin-right: 0.5em" />
        <span>{{ value.expiresAt | Moment('DD. MMM [kl.] HH.mm') }}</span>
      </div>
    </template>
    <template #details>
      <div>
        <FontAwesomeIcon :icon="['fal', 'address-card']" style="margin-right: 3px" />
        {{ value.reference.name }}
      </div>
    </template>
  </Item>
</template>

<script>
import Item from '@/components/ListItem'
import { Moment } from '@/filters'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  filters: {
    Moment,
  },
  computed: {
    title() {
      return `${this.value.title} - ${this.$t('accept')} / ${this.$t('decline')}`
    },
  },
  components: {
    Item,
  },
}
</script>

<style lang="scss">
.list-item--customcontract {
  a {
    text-decoration: none;
  }
}
</style>
